<template>
  <div>
    <div class="principal-integracionexpediente-incode">
      <div id="incode">
        <div v-show="seleccionandoID" class="col-lg-12 mb-3">
          <h3>
            {{
              tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                ? "¡Bienvenido!"
                : "Welcome!"
            }}
          </h3>
          <label>
            {{
              tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                ? "Por favor selecciona un tipo de identificación para comprobar tu identidad durante el proceso."
                : "Please select an ID type to verify your identity during the process."
            }}
          </label>
        </div>
        <div
          v-show="seleccionandoID"
          class="col-lg-12 mb-3"
          v-if="tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7"
        >
          <DropDown
            :disabled="false"
            placeholder="Selecciona tipo de identificación *"
            :arreglo="catalogos.tipoIdentificacion"
            llave="value"
            valor="value"
            texto="text"
            v-model="tipoID"
          ></DropDown>
        </div>
        <div v-show="seleccionandoID" class="col-lg-12 mb-3" v-else>
          <DropDown
            :disabled="false"
            placeholder="Select type of identification *"
            :arreglo="catalogosExtranjero.tipoIdentificacionExtranjero"
            llave="value"
            valor="value"
            texto="text"
            v-model="tipoID"
          ></DropDown>
        </div>
        <div class="row row-cols-lg-12 mb-3">
          <div class="col-lg-12 contenedor-botones-pago">
            <button
              v-if="tipoID != null"
              class="
                btn-Onboarding
                boton-primario boton-accion-pago
                contenedor-boton-finaliza-pago__boton
              "
              @click="IniciaOnboarding()"
            >
              {{
                tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7
                  ? "Continuar"
                  : "Next"
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//Plugins
import axios from "axios";
import DropDown from "../components/DropDown.vue";
//Variables
let onBoarding;
let session = null;
let score = null;
let status = null;
let container = null;
const API_URL = process.env.VUE_APP_URL_API_INCODE;
const CLIENT_ID = process.env.VUE_APP_CLIENTID_INCODE;
const flow_Id = process.env.VUE_APP_FLOWID_INCODE;
const transaction_Id = process.env.VUE_APP_TRANSACTIONID_INCODE;
const rutaConsultaDatosBuro = "/api/Master/Prospecto/ObtenerDatosProspectoBuro";
const rutaActualizacion =
  process.env.VUE_APP_URL_FIRMASIMPLE_API +
  "/api/Master/FirmaSimple/GuardarConsultaAutorizacionBuroCredito";
const rutaGuardaSesionIncode =
  process.env.VUE_APP_URL_FIRMASIMPLE_API +
  "/api/Master/FirmaSimple/GuardaDatosSesionOnBoarding";
const rutaActualizaSesionIncode =
  process.env.VUE_APP_URL_FIRMASIMPLE_API +
  "/api/Master/FirmaSimple/ActualizaDatosSesionOnBoarding";
const rutaConsultaSesionIncode =
  process.env.VUE_APP_URL_FIRMASIMPLE_API +
  "/api/Master/FirmaSimple/ConsultaDatosSesionOnBoarding";
const qrImg = process.env.VUE_APP_URL_QR_INCODE;
const rutaObtenerRepresentanteLegalProspecto =
  "/api/Master/Prospecto/ObtenerProspectoRepresentanteLegal";

export default {
  name: "IntegracionExpedienteIncode",
  components: {
    DropDown,
  },
  data() {
    return {
      // other data
      telefonoprospecto: null,
      tipoPersona: null,
      ProspectoId: null,
      OnboardingId: null,
      resultsession: false,
      DatosPersonales: null,
      SesionExistente: null,
      ProspectoRepresentanteLegalId: 0,
      error: null,
      seleccionandoID: false,
      tipoID: null,
      catalogos: {
        tipoIdentificacion: [
          { text: "INE/IFE", value: 1 },
          { text: "PASAPORTE", value: 2 },
        ],
      },
      catalogosExtranjero: {
        tipoIdentificacionExtranjero: [
          { text: "INE/IFE", value: 1 },
          { text: "PASSPORT", value: 2 },
        ],
      },
    };
  },
  async mounted() {
    document.getElementsByClassName(
      "principal-menu-navegacion"
    )[0].style.display = "none";
    this.telefonoprospecto = this.$store.getters.telefonoprospecto;
    this.tipoPersona = this.$store.getters.tipoPersona;
    this.ProspectoId = this.$store.getters.prospectoId;
    this.ProspectoRepresentanteLegalId = this.$store.getters.prospectoRepresentanteLegalId;
    await this.ConsultaProspectoRepresentanteLegal();
    try {
      this.SesionExistente = await this.ConsultaSesionIncode();
      if (this.SesionExistente != null) {
        if (this.SesionExistente.finishStatus == "COMPLETE") {
          this.seleccionandoID = false;
          this.AlertaEmbajadores(
            this.tipoPersona == 2 ||
              this.tipoPersona == 5 ||
              this.tipoPersona == 7
              ? "Thank you for authenticating your identity!"
              : "¡Gracias por autenticar tu identidad!",
            true,
            this.tipoPersona == 2 ||
              this.tipoPersona == 5 ||
              this.tipoPersona == 7
              ? true : false
          );
          return;
        }
      }
      this.seleccionandoID = true;
      container = document.getElementById("incode");
      onBoarding = await this.createOnBoarding();
      if (onBoarding.isDesktop()) {
        this.tipoPersona == 2 ||
        this.tipoPersona == 5 ||
        this.tipoPersona == 7
        ? (container.innerHTML =
        '<br/><br/><br/><b style="font-size:25px;">Enter the following league: <br/>' +
        window.location.protocol +
        "//" +
        window.location.host +
        "/LoginMaster<b/><br/> from your mobile phone or scan the QR code to continue...<br/><br/>" +
        '<img src="' +
        qrImg +
        '" height="300px" width="300px"/><br/><br/>')        
        : (container.innerHTML =
          '<br/><br/><br/><b style="font-size:25px;">Ingresa a la siguiente liga: <br/>' +
          window.location.protocol +
          "//" +
          window.location.host +
          "/LoginMaster<b/><br/> desde tu celular o escanea el codigo QR para continuar...<br/><br/>" +
          '<img src="' +
          qrImg +
          '" height="300px" width="300px"/><br/><br/>'),
          this.AlertaEmbajadores(
            this.tipoPersona == 2 ||
              this.tipoPersona == 5 ||
              this.tipoPersona == 7
              ? "To authenticate your identity it is necessary to continue the process from your mobile phone, please follow the instructions on the screen."
              : "Para realizar la autentificación de tu identidad es necesario continuar el proceso desde tu móvil, por favor sigue las instrucciones que aparecen en la pantalla.",
            true,
            this.tipoPersona == 2 ||
              this.tipoPersona == 5 ||
              this.tipoPersona == 7
              ? true : false
          );
        return;
      }
    } catch (e) {
      container.innerHTML =
        this.tipoPersona == 2 || this.tipoPersona == 5 || this.tipoPersona == 7
          ? `<p>Could not complete the operation, please refresh the page</p>`
          : `<p>No se pudo completar la operación, por favor actualiza la página</p>`;
      throw e;
    }
  },
  methods: {
    async IniciaOnboarding() {
      let temporal = this.prospectoId;
      if (this.tipoID != null) {
        container.innerHTML =
          this.tipoPersona == 2 ||
          this.tipoPersona == 5 ||
          this.tipoPersona == 7
            ? `<p>Starting...</p>`
            : `<p>Iniciando...</p>`;
        await onBoarding.warmup();
        container.innerHTML =
          this.tipoPersona == 2 ||
          this.tipoPersona == 5 ||
          this.tipoPersona == 7
            ? `<p>Creating session...</p>`
            : `<p>Creando sesión...</p>`;
        session = await this.createSession();
        onBoarding.session = session;
        if (this.tipoPersona == 1) {
          this.prospectoId = this.ProspectoRepresentanteLegalId;
        }
        this.GuardadoSesion().then((resultado) => {
          if (resultado.onboardingId > 0) {
            this.CargaPantallaOnboarding();
          } else {
            container.innerHTML =
              this.tipoPersona == 2 ||
              this.tipoPersona == 5 ||
              this.tipoPersona == 7
                ? `<p>Could not create session, please refresh the page</p>`
                : `<p>No se pudo crear la sesion, por favor actualiza la página</p>`;
          }
        });

        this.prospectoId = temporal;
      } else {
        container.innerHTML =
          this.tipoPersona == 2 ||
          this.tipoPersona == 5 ||
          this.tipoPersona == 7
            ? `<p>You must select a type of identification.`
            : `<p>Debes de seleccionar un tipo de identificación.</p>`;
      }
    },
    async ConsultaProspectoRepresentanteLegal() {
       const parametroProspectoId = {
        params: {
          ProspectoId: this.ProspectoId,
        },
      };
      axios
        .get(rutaObtenerRepresentanteLegalProspecto, parametroProspectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.ProspectoRepresentanteLegalId = resp.data.data;
            this.$store.commit(
              "setProspectoRepresentanteLegal",
              this.ProspectoRepresentanteLegalId
            );
            //Revisa si la solicitud tiene una observación
            // this.SolicitudRepresentanteTieneObservacion(
            //   this.ProspectoRepresentanteLegalId,
            //   2
            // );
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, false,
            this.tipoPersona == 2 ||
              this.tipoPersona == 5 ||
              this.tipoPersona == 7
              ? true : false);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    createOnBoarding() {
      const apiURL = API_URL;
      const clientId = CLIENT_ID;
      return window.OnBoarding.create({
        clientId: clientId,
        apiURL: apiURL,
        lang:
          this.tipoPersona == 2 ||
          this.tipoPersona == 5 ||
          this.tipoPersona == 7
            ? "en"
            : "es",
        theme: {
          // main: "",
          // mainButton: {
          //   borderRadius: "",
          //   color: "",
          //   border: "",
          // },
        },
      });
    },
    renderFinishScreen: function() {
      if (
        this.tipoPersona == 2 ||
        this.tipoPersona == 5 ||
        this.tipoPersona == 7
      ) {
        this.$router.push({
          name: "IntegracionExpedienteExtranjero",
        });
      } else if (this.tipoPersona == 1) {
        this.$router.push({
          name: "IntegracionExpedienteMoral",
        });
      } else {
        this.$router.push({
          name: "IntegracionExpediente",
        });
      }
    },
    createSession: function() {
      return onBoarding.createSession("ALL", null, {
        configurationId: flow_Id,
        externalId: transaction_Id,
      });
    },
    showError: function() {
      this.AlertaEmbajadores(this.error, true,
            this.tipoPersona == 2 ||
              this.tipoPersona == 5 ||
              this.tipoPersona == 7
              ? true : false);
    },
    renderFrontIDCamera: async function() {
      if (
        this.tipoPersona == 2 ||
        this.tipoPersona == 5 ||
        this.tipoPersona == 7
      ) {
        if (this.tipoID == 2) {
          onBoarding.renderCamera("passport", container, {
            //Case dependiendo tipo de identificacion Implementar
            onSuccess: async () => {
              score = await onBoarding.getScore({ token: session.token });
              this.processId();
            },
            onError: () => {
              this.error =
                this.tipoPersona == 2 ||
                this.tipoPersona == 5 ||
                this.tipoPersona == 7
                  ? "Could not successfully validate the front photo, please reload the page and try again."
                  : "No se pudo validar de manera correcta la foto frontal, por favor recarga la pagina y vuelve a intentarlo";
              this.showError();
            },
            token: session,
            showTutorial: true,
            numberOfTries: -1,
            noWait: true,
          });
        } else {
          onBoarding.renderCamera("front", container, {
            //Case dependiendo tipo de identificacion
            onSuccess: async () => {
              score = await onBoarding.getScore({ token: session.token });
              this.renderBackIDCamera();
            },
            onError: () => {
              this.error =
                this.tipoPersona == 2 ||
                this.tipoPersona == 5 ||
                this.tipoPersona == 7
                  ? "Could not successfully validate the front photo, please reload the page and try again."
                  : "No se pudo validar de manera correcta la foto frontal, por favor recarga la pagina y vuelve a intentarlo";
              this.showError();
            },
            token: session,
            showTutorial: true,
            numberOfTries: -1,
            noWait: true,
          });
        }
        // onBoarding.renderCamera("passport", container, {
        //   //Case dependiendo tipo de identificacion
        //   onSuccess: async () => {
        //     score = await onBoarding.getScore({ token: session.token });
        //     this.processId();
        //   },
        //   onError: () => {
        //     this.error =
        //       "No se pudo validar de manera correcta la foto frontal, por favor recarga la pagina y vuelve a intentarlo";
        //     this.showError();
        //   },
        //   token: session,
        //   showTutorial: true,
        //   numberOfTries: -1,
        //   noWait: true,
        // });
      } else {
        if (this.tipoID == 2) {
          onBoarding.renderCamera("passport", container, {
            //Case dependiendo tipo de identificacion Implementar
            onSuccess: async () => {
              score = await onBoarding.getScore({ token: session.token });
              this.processId();
            },
            onError: () => {
              this.error =
                this.tipoPersona == 2 ||
                this.tipoPersona == 5 ||
                this.tipoPersona == 7
                  ? "Could not successfully validate the front photo, please reload the page and try again."
                  : "No se pudo validar de manera correcta la foto frontal, por favor recarga la pagina y vuelve a intentarlo";
              this.showError();
            },
            token: session,
            showTutorial: true,
            numberOfTries: -1,
            noWait: true,
          });
        } else {
          onBoarding.renderCamera("front", container, {
            //Case dependiendo tipo de identificacion
            onSuccess: async () => {
              score = await onBoarding.getScore({ token: session.token });
              this.renderBackIDCamera();
            },
            onError: () => {
              this.error =
                this.tipoPersona == 2 ||
                this.tipoPersona == 5 ||
                this.tipoPersona == 7
                  ? "Could not successfully validate the front photo, please reload the page and try again."
                  : "No se pudo validar de manera correcta la foto frontal, por favor recarga la pagina y vuelve a intentarlo";
              this.showError();
            },
            token: session,
            showTutorial: true,
            numberOfTries: -1,
            noWait: true,
          });
        }
      }
    },
    renderBackIDCamera: async function() {
      onBoarding.renderCamera("back", container, {
        onSuccess: async () => {
          score = await onBoarding.getScore({ token: session.token });
          this.processId();
        },
        onError: () => {
          this.error =
            this.tipoPersona == 2 ||
            this.tipoPersona == 5 ||
            this.tipoPersona == 7
              ? "Could not successfully validate the back photo, please reload the page and try again."
              : "No se pudo validar de manera correcta la foto trasera, por favor recarga la pagina y vuelve a intentarlo";
          this.showError();
        },
        token: session,
        numberOfTries: -1,
      });
    },
    processId: async function() {
      container.innerHTML =
        this.tipoPersona == 2 || this.tipoPersona == 5 || this.tipoPersona == 7
          ? "<p>Loading...</p>"
          : "<p>Cargando...</p>";
      onBoarding.processId({ token: session.token }).then(async () => {
        score = await onBoarding.getScore({ token: session.token });
        if (score != null && score.idValidation.overall.status == "OK") {
          container.innerHTML =
            this.tipoPersona == 2 ||
            this.tipoPersona == 5 ||
            this.tipoPersona == 7
              ? "Validated..."
              : "Validado...";
          this.renderSelfieCamera();
        } else {
          this.error =
            this.tipoPersona == 2 ||
            this.tipoPersona == 5 ||
            this.tipoPersona == 7
              ? "Did not reach the minimum score for ID validation, please reload the page and try again."
              : "No se alcanzo el puntaje minimo para la validacion de la identificación, por favor recarga la pagina y vuelve a intentarlo";
          this.showError();
        }
      });
    },
    renderSelfieCamera: async function() {
      onBoarding.renderCamera("selfie", container, {
        onSuccess: async () => {
          score = await onBoarding.getScore({ token: session.token });
          if (score != null && score.overall.status == "OK") {
            container.innerHTML =
              this.tipoPersona == 2 ||
              this.tipoPersona == 5 ||
              this.tipoPersona == 7
                ? "Loading Signature..."
                : "Cargando Firma...";
            this.renderSignature();
          } else {
            this.error =
              this.tipoPersona == 2 ||
              this.tipoPersona == 5 ||
              this.tipoPersona == 7
                ? "Our system could not validate your selfie. Please reload the page or press accept to repeat the process."
                : "Nuestro sistema no pudo validar tu selfie. Por favor, recarga la página o presiona aceptar para repetir el proceso.";
            this.showError();
          }
        },
        onError: () => {
          this.error =
            this.tipoPersona == 2 ||
            this.tipoPersona == 5 ||
            this.tipoPersona == 7
              ? "Could not successfully capture the selfie photo, please reload the page and try again."
              : "No se pudo capturar de manera correcta la foto de la selfie, por favor recarga la pagina y vuelve a intentarlo";
          this.showError();
        },
        token: session,
        numberOfTries: 3,
      });
    },
    renderSignature: async function() {
      onBoarding.renderSignature(container, {
        token: session.token,
        onSuccess: async () => {
          container.innerHTML =
            this.tipoPersona == 2 ||
            this.tipoPersona == 5 ||
            this.tipoPersona == 7
              ? "Processing..."
              : "Procesando...";
          container.innerHTML =
            this.tipoPersona == 2 ||
            this.tipoPersona == 5 ||
            this.tipoPersona == 7
              ? "<p>Finishing....</p>"
              : `<p>Finalizando....</p>`;
          status = await onBoarding.getFinishStatus(flow_Id, {
            token: session.token,
          });
          if (status) {
            await this.ActualizaSesionIncode().then((sessionEstatus) => {
              if (sessionEstatus) {
                if (
                  this.tipoPersona == 2 ||
                  this.tipoPersona == 5 ||
                  this.tipoPersona == 7
                ) {
                  this.$router.push({
                    name: "IntegracionExpedienteExtranjero",
                    params: {
                      respuestaIncode: true,
                    },
                  });
                } else if (this.tipoPersona == 1) {
                  this.$router.push({
                    name: "IntegracionExpedienteMoral",
                    params: {
                      respuestaIncode: true,
                    },
                  });
                } else {
                  this.$router.push({
                    name: "IntegracionExpediente",
                    params: {
                      respuestaIncode: true,
                    },
                  });
                }
              } else {
                this.AlertaEmbajadores(
                  this.tipoPersona == 2 ||
                    this.tipoPersona == 5 ||
                    this.tipoPersona == 7
                    ? "An error occurred while performing the Incode closing operation, please contact the technical area to solve the problem."
                    : "Ocurrio un error al realizar la operacion de cierre Incode, por favor contacte al area tecnica para dar solucion al problema.",
                  true,
                  this.tipoPersona == 2 ||
                  this.tipoPersona == 5 ||
                  this.tipoPersona == 7
                  ? true : false
                );
              }
            });
          } else {
            this.AlertaEmbajadores(
              this.tipoPersona == 2 ||
                this.tipoPersona == 5 ||
                this.tipoPersona == 7
                ? "An error occurred while trying to end the session, please try again."
                : "Ocurrio un error al intentar finalizar la sesion, por favor intentalo nuevamente.",
              true,
              this.tipoPersona == 2 ||
              this.tipoPersona == 5 ||
              this.tipoPersona == 7
              ? true : false
            );
          }
        },
        onError: () => {
          this.error =
            this.tipoPersona == 2 ||
            this.tipoPersona == 5 ||
            this.tipoPersona == 7
              ? "An error occurred while capturing the digital signature, please reload the page and try again."
              : "Ocurrio un error al capturar la firma digital, por favor recarga la pagina y vuelve a intentarlo";
          this.showError();
        },
      });
    },
    async CargaPantallaOnboarding() {
      this.seleccionandoID = false;
      await onBoarding
        .sendGeolocation({ token: session.token })
        .catch(console.log);
      container.innerHTML = "";
      this.renderFrontIDCamera();
    },
    ConsultarDatosBuroCredito() {
      const prospectoId = {
        params: {
          ProspectoId: this.tipoPersona == 1 ? this.ProspectoRepresentanteLegalId : this.ProspectoId,
        },
      };
      return axios
        .get(rutaConsultaDatosBuro, prospectoId)
        .then((resp) => {
          if (resp.data.estado === 0) {
            this.DatosPersonales = resp.data.data.data;
          } else {
            this.AlertaEmbajadores(resp.data.mensaje, true,
            this.tipoPersona == 2 ||
              this.tipoPersona == 5 ||
              this.tipoPersona == 7
              ? true : false);
          }
          return this.DatosPersonales;
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    EnviarActualizacionDatos() {
      return axios
        .post(rutaActualizacion, this.DatosPersonales)
        .then((resp) => {
          if (resp.data.data != 0) {
            if (
              this.tipoPersona == 2 ||
              this.tipoPersona == 5 ||
              this.tipoPersona == 7
            ) {
              this.$router.push({
                name: "IntegracionExpedienteExtranjero",
                params: {
                  respuestaIncode: true,
                },
              });
            } else if (this.tipoPersona == 1) {
              this.$router.push({
                name: "IntegracionExpedienteMoral",
                params: {
                  respuestaIncode: true,
                },
              });
            } else {
              this.$router.push({
                name: "IntegracionExpediente",
                params: {
                  respuestaIncode: true,
                },
              });
            }
            // this.$router.push({
            //   name: "IntegracionExpediente",
            // });
          } else {
            this.AlertaEmbajadores(resp.data.mensaje, true,
            this.tipoPersona == 2 ||
              this.tipoPersona == 5 ||
              this.tipoPersona == 7
              ? true : false);
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    async GuardadoSesion() {
      let oBjOnboarding = {
        onboardingId: 0,
        prospectoId: this.tipoPersona == 1 ? this.ProspectoRepresentanteLegalId : this.ProspectoId,
        clientId: session.clientId,
        curpValidationRetries: session.curpValidationRetries,
        env: session.env,
        flowType: session.flowType,
        idCaptureRetries: session.idCaptureRetries,
        idCaptureTimeout: session.idCaptureTimeout,
        interviewCode: session.interviewCode,
        interviewId: session.interviewId,
        selfieCaptureRetries: session.selfieCaptureRetries,
        selfieCaptureTimeout: session.selfieCaptureTimeout,
        token: session.token,
        finishStatus: "INCOMPLETE",
        aplicacionId: 0,
      };
      return axios
        .post(rutaGuardaSesionIncode, oBjOnboarding)
        .then((resp) => {
          if (resp.data.estado == "OK") {
            if (resp.data.data.onboardingId > 0) {
              this.OnboardingId = resp.data.data.onboardingId;
            }
          }
          return resp.data.data;
        })
        .catch((e) => this.ManejarExcepcion(e));
    },
    async ActualizaSesionIncode() {
      let oBjOnboarding = {
        onboardingId: this.OnboardingId,
        prospectoId: this.tipoPersona == 1 ? this.ProspectoRepresentanteLegalId : this.ProspectoId,
        clientId: session.clientId,
        curpValidationRetries: session.curpValidationRetries,
        env: session.env,
        flowType: session.flowType,
        idCaptureRetries: session.idCaptureRetries,
        idCaptureTimeout: session.idCaptureTimeout,
        interviewCode: session.interviewCode,
        interviewId: session.interviewId,
        selfieCaptureRetries: session.selfieCaptureRetries,
        selfieCaptureTimeout: session.selfieCaptureTimeout,
        token: session.token,
        finishStatus: "COMPLETE",
        aplicacionId: 0,
      };
      return axios
        .post(rutaActualizaSesionIncode, oBjOnboarding)
        .then((resp) => {
          if (resp.data.estado === "OK") {
            return true;
          } else {
            this.AlertaEmbajadores(resp.data.mensaje, true,
            this.tipoPersona == 2 ||
              this.tipoPersona == 5 ||
              this.tipoPersona == 7
              ? true : false);
            return false;
          }
        })
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
    async ConsultaSesionIncode() {
      const prospectoId = {
        params: {
          ProspectoId: this.tipoPersona == 1 ? this.ProspectoRepresentanteLegalId : this.ProspectoId,
          AplicacionId: 0,
        },
      };
      return axios
        .get(rutaConsultaSesionIncode, prospectoId)
        .then((resp) => resp.data.data)
        .catch((e) => {
          this.ManejarExcepcion(e);
        });
    },
  },
};
</script>
<style lang="scss">
@import "../../../../../assets/estilos/estilosIncode.scss";
$color-primario: #b8725a;
$blanco: #ffffff;
$poppins: "Poppins";
.btn-Onboarding {
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  color: $blanco;
  background-color: #a56651;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.boton-primario {
  border-radius: 0px;
  background-color: $color-primario;
  box-shadow: none;
  color: $blanco;
  font-family: $poppins;
}
.boton-primario:hover {
  color: $blanco;
  background-color: #a56651;
}
.boton-primario:focus {
  box-shadow: none;
}
.boton-accion-pago {
  height: 45px;
  margin-left: 20px;
}
.contenedor-boton-finaliza-pago {
  margin-top: auto;
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
}
.contenedor-boton-finaliza-pago__boton {
  width: 30%;
}
@media all and (max-width: 767px) {
  .btn-Onboarding {
    display: inline-block;
    font-weight: 400;
    line-height: 1.5;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    color: $blanco;
    background-color: #a56651;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
  .boton-accion-pago {
    height: 45px;
    margin-left: 0px;
    margin-top: 15px;
  }
  .contenedor-boton-finaliza-pago {
    height: auto;
    margin-top: 50px;
    display: flex;
    justify-content: center;
  }
  .contenedor-boton-finaliza-pago__boton {
    width: 75%;
  }
}
</style>
